type KioskSuccessSplashProps = {
  variant: "welcome" | "already";
  name: string;
  onDismiss: () => void;
};

export function KioskSuccessSplash({ variant, name, onDismiss }: KioskSuccessSplashProps) {
  const isWelcome = variant === "welcome";
  return (
    <div className="kiosk-success" role="status" aria-live="polite">
      <div className="kiosk-success-inner">
        <div className="sec-eyebrow">
          <em>{isWelcome ? "you’re in" : "already here"}</em>
        </div>
        <h2 className="kiosk-success-title">
          {isWelcome ? `Welcome, ${name}` : "You’re already in"}
        </h2>
        <p className="kiosk-success-lede">
          {isWelcome
            ? "You’re checked in. A host can help if you need anything."
            : `${name}, you’re already checked in for tonight. Enjoy the gathering.`}
        </p>
        <button type="button" className="btn btn-primary kiosk-btn" onClick={onDismiss}>
          Next person
        </button>
      </div>
    </div>
  );
}
